import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/browser";
import config from "./config.json";
import { ThemeProvider } from "styled-components";
import { RecoilRoot } from "recoil";
import { theme } from "theme";
import { Provider } from "react-redux";
import store from "./redux/store";

if (config.env === "prod") {
  Sentry.init({
    dsn: "https://5309f8c710ae4dc1a3ec70e063fe2960@o323278.ingest.sentry.io/5390384",
  });
} else {
  Sentry.init({
    dsn: "https://d877e3b424db42d3806b7ac333f192b3@o323278.ingest.sentry.io/5390933",
  });
}

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(
    <ThemeProvider theme={theme}>
      <RecoilRoot>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </RecoilRoot>
    </ThemeProvider>,
    rootElement
  );
} else {
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <RecoilRoot>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </RecoilRoot>
    </ThemeProvider>,
    rootElement
  );
}
// ReactDOM.render ( <BrowserRouter>
// <App />
// </BrowserRouter>
// , rootElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister({
  // onUpdate: registration => {
  //   const waitingServiceWorker = registration.waiting
  //   if (waitingServiceWorker) {
  //     waitingServiceWorker.addEventListener('statechange', event => {
  //       console.log('%c Service Worker ',
  //           'color: white; background-color: #95B46A',
  //           'Service Worker updated');
  //       if (event.target.state === 'activated') {
  //       }
  //     });
  //     waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
  //   }
  // }
});
